import { render, staticRenderFns } from "./bubble2.vue?vue&type=template&id=7cd892b2&scoped=true"
import script from "./bubble2.vue?vue&type=script&lang=js"
export * from "./bubble2.vue?vue&type=script&lang=js"
import style0 from "./bubble2.vue?vue&type=style&index=0&id=7cd892b2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cd892b2",
  null
  
)

export default component.exports